import { useMutation } from 'react-query';
import {
  getQuestReportWorkOrderAdministrativeReport,
  getQuestReportWorkOrderCost,
  getQuestReportWorkOrderPermanenceDeclaration,
  getQuestReportWorkOrderTotalPerWorkOrder,
  getQuestReportWorkOrderWorkshop,
  getReportWorkOrderAdministrativePublic,
} from './WorkOrder.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';

export function useQuestReportWorkOrderAdministrativeReport() {
  return useMutation(getQuestReportWorkOrderAdministrativeReport, {
    onSuccess() {
      notification.success({
        message: 'Relatório Administrativo gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useReportWorkOrderAdministrativePublic() {
  return useMutation(getReportWorkOrderAdministrativePublic, {
    onSuccess() {
      notification.success({
        message: 'Relatório Administrativo gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useQuestReportWorkOrderCost() {
  return useMutation(getQuestReportWorkOrderCost, {
    onSuccess() {
      notification.success({
        message: 'Relatório de Custo da OS gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useQuestReportWorkOrderWorkshop() {
  return useMutation(getQuestReportWorkOrderWorkshop, {
    onSuccess() {
      notification.success({
        message: 'Relatório para oficina gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useQuestReportWorkOrderTotalPerWorkOrder() {
  return useMutation(getQuestReportWorkOrderTotalPerWorkOrder, {
    onSuccess() {
      notification.success({
        message: 'Relatório Total por Orçamento gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useQuestReportPermanenceDeclaration() {
  return useMutation(getQuestReportWorkOrderPermanenceDeclaration, {
    onSuccess() {
      notification.success({
        message: 'Relatório declaração de permanência gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
